import { render, staticRenderFns } from "./tree-templateField.vue?vue&type=template&id=19cb57ce&"
import script from "./tree-templateField.vue?vue&type=script&lang=js&"
export * from "./tree-templateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports